<template>
  <div class="card flex justify-center">
    <Drawer
      v-model:visible="visible"
      position="right"
      class="!backdrop-blur-lg dark:!bg-[#8542b410] !w-[22rem]"
    >
      <template #container="{ closeCallback }">
        <div class="flex flex-col h-full">
          <div class="flex items-center justify-between p-2 shrink-0">
            <NuxtLink to="/" class="flex items-center text-2xl">
              <video autoplay loop muted playsinline width="40" height="29">
                <source src="/images/WRI-logo2.webm" type="video/webm" />
              </video>
              <span class="text-[var(--foreground)]"
                ><span
                  class="border-l pl-2 border-[#B88ABE50] mt-1 font-semibold"
                  >web</span
                >reinvent</span
              >
            </NuxtLink>
            <span>
              <button class="p-1 rounded-full border dark:border-white/50">
                <WrCross @click="closeCallback" width="24" height="24" />
              </button>
            </span>
          </div>
          <div class="overflow-y-auto">
            <ul class="pt-4" v-for="item in items" :key="item.label">
              <li>
                <NuxtLink
                  :to="item.link"
                  v-ripple
                  v-styleclass="{
                    selector: '@next',
                    enterFromClass: 'hidden',
                    enterActiveClass: 'animate-slidedown',
                    leaveToClass: 'hidden',
                    leaveActiveClass: 'animate-slideup',
                  }"
                  class="px-4 py-2 flex items-center justify-between dark: cursor-pointer p-ripple"
                >
                  <span class="flex items-center gap-2">
                    <!-- <span class="mr-2 size-6 shrink-0 block" /> -->
                    <component :is="item.icon" />
                    <span class="font-medium">{{ item.label }}</span>
                  </span>
                  <WrDown v-if="item.items" />
                </NuxtLink>
                <ul class="list-none p-0 m-0 overflow-hidden">
                  <li v-for="item in item.items" :key="item.item">
                    <NuxtLink
                      :to="item.link"
                      v-ripple
                      v-styleclass="{
                        selector: '@next',
                        enterFromClass: 'hidden',
                        enterActiveClass: 'animate-slidedown',
                        leaveToClass: 'hidden',
                        leaveActiveClass: 'animate-slideup',
                      }"
                      class="flex items-center justify-between cursor-pointer px-4 py-2 rounded duration-150 transition-colors p-ripple"
                    >
                      <span class="flex items-center gap-2">
                        <!-- <span class="mr-2 size-6 bg-[url(/images/menu-icons.webp)]" /> -->
                        <component :is="item.icon" width="20" height="20" />
                        <span class="font-medium">{{ item.label }}</span>
                      </span>
                      <WrDown v-if="item.items" />
                    </NuxtLink>
                    <ul
                      class="list-none py-0 pl-4 pr-0 m-0 hidden overflow-y-hidden transition-all duration-[400ms] ease-in-out"
                    >
                      <li v-for="item in item.items" :key="item.item">
                        <NuxtLink
                          :to="item.link"
                          v-ripple
                          v-styleclass="{
                            selector: '@next',
                            enterFromClass: 'hidden',
                            enterActiveClass: 'animate-slidedown',
                            leaveToClass: 'hidden',
                            leaveActiveClass: 'animate-slideup',
                          }"
                          class="flex items-center justify-between cursor-pointer px-4 py-2 rounded duration-150 transition-colors p-ripple"
                        >
                          <span class="flex items-center gap-2">
                            <span
                              class="mr-2 size-6"
                              v-if="
                                item.iconPosition !== 'bg-[position:0px_0px]'
                              "
                              :class="[
                                item.iconPosition,
                                $colorMode.preference == 'dark'
                                  ? 'bg-[url(/images/menu-icons.webp)]'
                                  : 'bg-[url(/images/menu-icons-light.webp)]',
                              ]"
                            />
                            <!-- Fallback icon (first letter) -->
                            <span
                              v-else
                              class="mr-2 size-6 flex items-center justify-center rounded-full text-white text-xs font-semibold"
                              :style="{
                                backgroundColor: getColorForLabel(item.label),
                              }"
                            >
                              {{ item.label.charAt(0).toUpperCase() }}
                            </span>
                            <!-- <component :is="item.icon" width="20" height="20" /> -->
                            <span
                              class="font-medium"
                              @click="visible = item.items"
                              >{{ item.label }}</span
                            >
                          </span>
                          <WrDown v-if="item.items" />
                        </NuxtLink>
                        <ul
                          class="list-none py-0 pl-4 pr-0 m-0 hidden overflow-y-hidden transition-all duration-[400ms] ease-in-out"
                        >
                          <li v-for="item in item.items" :key="item.item">
                            <NuxtLink
                              :to="item.link"
                              v-ripple
                              class="flex items-center cursor-pointer px-4 py-2 rounded duration-150 transition-colors p-ripple"
                              @click="visible = false"
                            >
                              <span class="flex items-center gap-2">
                                <span
                                  class="mr-2 size-6"
                                  v-if="
                                    item.iconPosition !==
                                    'bg-[position:0px_0px]'
                                  "
                                  :class="[
                                    item.iconPosition,
                                    $colorMode.preference == 'dark'
                                      ? 'bg-[url(/images/menu-icons.webp)]'
                                      : 'bg-[url(/images/menu-icons-light.webp)]',
                                  ]"
                                />
                                <!-- Fallback icon (first letter) -->
                                <span
                                  v-else
                                  class="mr-2 size-6 flex items-center justify-center rounded-full text-white text-xs font-semibold"
                                  :style="{
                                    backgroundColor: getColorForLabel(
                                      item.label
                                    ),
                                  }"
                                >
                                  {{ item.label.charAt(0).toUpperCase() }}
                                </span>
                                <!-- <component :is="item.icon" width="20" height="20" /> -->
                                <span class="font-medium">{{
                                  item.label
                                }}</span>
                              </span>

                              <WrDown v-if="item.items" />
                            </NuxtLink>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </Drawer>
    <WrHamburger @click="visible = true" width="24" height="24" />
  </div>
</template>

<script setup>
import { ref } from "vue";

import { useGlobalStore } from "~/stores/globalStore";
const globalStore = useGlobalStore();

import WrDown from "~/components/atoms/icons/WrDown.vue";
import WrCross from "../atoms/icons/WrCross.vue";
import WrHamburger from "../atoms/icons/WrHamburger.vue";
import WrAI from "~/components/atoms/icons/WrAI.vue";
import WrDesign from "~/components/atoms/icons/WrDesign.vue";
import WrDesktop from "~/components/atoms/icons/WrDesktop.vue";
import WrFolder from "~/components/atoms/icons/WrFolder.vue";
import WrFrameworks from "~/components/atoms/icons/WrFrameworks.vue";
import WrIndustries from "~/components/atoms/icons/WrIndustries.vue";
import WrMobile from "~/components/atoms/icons/WrMobile.vue";
import WrProducts from "~/components/atoms/icons/WrProducts.vue";
import WrSettings from "~/components/atoms/icons/WrSettings.vue";
import WrContentFrameworks from "~/components/global/WrContentFrameworks.vue";
import WrMenuContent from "~/components/global/WrMenuContent.vue";
import WrDevelopment from "../atoms/icons/WrDevelopment.vue";

const visible = ref(false);

const colors = [
  "#A44AE1",
  "#4AE1A4",
  "#E14A4A",
  "#4A6BE1",
  "#E1A44A",
  "#FF7F50",
  "#9370DB",
  "#20B2AA",
  "#FF69B4",
  "#6495ED",
];

function getColorForLabel(label) {
  // Pick a color based on the label hash
  const index = label.charCodeAt(0) % colors.length;
  return colors[index];
}

const items = ref([
  {
    label: "Services",
    items: [
      // {
      //     label: 'Design',
      //     icon: markRaw(WrDesign),
      //     items: [
      //         {
      //             label: 'Design System', iconPosition: "bg-[position:0px_0px]", item: 'item1', link: '/design-system'
      //         },
      //         {
      //             label: 'Brand Identity Design', iconPosition: "bg-[position:0px_-48px]", item: 'item2', link: '/brand-identity-design'
      //         },
      //         {
      //             label: 'UI/UX & Website Design', iconPosition: "bg-[position:0px_-96px]", item: 'item3', link: '/ui-ux-website-design'
      //         },
      //         {
      //             label: 'Design Thinking', iconPosition: "bg-[position:0px_-146px]", item: 'item4', link: '/design-thinking'
      //         },
      //         {
      //             label: 'Presentation Design', iconPosition: "bg-[position:0px_-192px]", item: 'item5', link: '/presentation-design'
      //         },
      //         {
      //             label: 'Ad Creative', iconPosition: "bg-[position:0px_-238px]", item: 'item6', link: '/ad-creative'
      //         },
      //         {
      //             label: 'Social Media Creative', iconPosition: "bg-[position:0px_-288px]", item: 'item7', link: '/social-media-creative'
      //         },
      //         {
      //             label: 'Mobile App Design', iconPosition: "bg-[position:0px_-336px]", item: 'item8', link: '/mobile-app-design'
      //         },
      //         {
      //             label: 'Illustration Design', iconPosition: "bg-[position:0px_-384px]", item: 'item9', link: '/illustration-design'
      //         },
      //         {
      //             label: 'Email Design', iconPosition: "bg-[position:0px_-432px]", item: 'item10', link: '/email-design'
      //         },
      //         {
      //             label: 'Animation/Motion Graphics', iconPosition: "bg-[position:0px_-480px]", item: 'item11', link: '/animation-motion-graphics'
      //         },
      //         {
      //             label: 'Video Production', iconPosition: "bg-[position:0px_-530px]", item: 'item12', link: '/video-production'
      //         },
      //         {
      //             label: 'Concept Creation', iconPosition: "bg-[position:0px_-576px]", item: 'item13', link: '/concept-creation'
      //         },
      //         {
      //             label: 'eBook & Digital Report Design', iconPosition: "bg-[position:0px_-624px]", item: 'item14', link: '/ebook-digital-report-design'
      //         },
      //         {
      //             label: 'Logo Design', iconPosition: "bg-[position:0px_-672px]", item: 'item15', link: '/logo-design'
      //         },
      //         {
      //             label: 'Print Design', iconPosition: "bg-[position:0px_-720px]", item: 'item16', link: '/print-design'
      //         },
      //         {
      //             label: 'Packaging & Merch Design', iconPosition: "bg-[position:0px_-768px]", item: 'item17', link: '/packaging-merch-design'
      //         },
      //         {
      //             label: 'AI - Enhanced Creative', iconPosition: "bg-[position:0px_-820px]", item: 'item18', link: '/ai-enhanced-creative'
      //         }
      //     ],

      // },
      {
        label: "View All",
        link: "/services",
      },
      {
        label: "Development Services",
        icon: markRaw(WrDevelopment),
        items: [
          { label: "View All", link: "/services/development-services", iconPosition: "bg-[position:0px_0px]" },
          {
            label: "AI Machine Learning Services",
            iconPosition: "bg-[position:0px_0px]",
            item: "ai-machine-learning-services",
            link: "/services/development-services/ai-machine-learning-services",
          },
          {
            label: "API Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "api-development",
            link: "/services/development-services/api-development",
          },
          {
            label: "Application Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "application-development",
            link: "/services/development-services/application-development",
          },
          {
            label: "Application Maintenance & Support",
            iconPosition: "bg-[position:0px_0px]",
            item: "application-maintenance-support",
            link: "/services/development-services/application-maintenance-support",
          },
          {
            label: "Automated Testing Service",
            iconPosition: "bg-[position:0px_0px]",
            item: "automated-testing-service",
            link: "/services/development-services/automated-testing-service",
          },
          {
            label: "Automation Testing",
            iconPosition: "bg-[position:0px_0px]",
            item: "automation-testing",
            link: "/services/development-services/automation-testing",
          },
          {
            label: "AWS Cloud & Migration Services",
            iconPosition: "bg-[position:0px_0px]",
            item: "aws-cloud-and-migration-services",
            link: "/services/development-services/aws-cloud-and-migration-services",
          },
          {
            label: "Blockchain Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "blockchain-development",
            link: "/services/development-services/blockchain-development",
          },
          {
            label: "Business Automation",
            iconPosition: "bg-[position:0px_0px]",
            item: "business-automation",
            link: "/services/development-services/business-automation",
          },
          {
            label: "Chatbot Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "chatbot-development",
            link: "/services/development-services/chatbot-development",
          },
          {
            label: "CMS Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "cms-development",
            link: "/services/development-services/cms-development",
          },
          {
            label: "Dedicated Development Team",
            iconPosition: "bg-[position:0px_0px]",
            item: "dedicated-development-team",
            link: "/services/development-services/dedicated-development-team",
          },
          {
            label: "Desktop Software Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "desktop-software-development",
            link: "/services/development-services/desktop-software-development",
          },
          {
            label: "DevOps Solutions",
            iconPosition: "bg-[position:0px_0px]",
            item: "devops-solutions",
            link: "/services/development-services/devops-solutions",
          },
          {
            label: "Docker Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "docker-development",
            link: "/services/development-services/docker-development",
          },
          {
            label: "Ecommerce Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "ecommerce-development",
            link: "/services/development-services/ecommerce-development",
          },
          {
            label: "FinTech Product Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "finTech-product-development",
            link: "/services/development-services/finTech-product-development",
          },
          {
            label: "FusionCharts Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "fusioncharts-development",
            link: "/services/development-services/fusioncharts-development",
          },
          {
            label: "IoT Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "iot-development",
            link: "/services/development-services/iot-development",
          },
          {
            label: "IT Consulting",
            iconPosition: "bg-[position:0px_0px]",
            item: "it-consulting",
            link: "/services/development-services/it-consulting",
          },
          {
            label: "Kubernetes Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "kubernetes-development",
            link: "/services/development-services/kubernetes-development",
          },
          {
            label: "Mobile App Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "mobile-app-development",
            link: "/services/development-services/mobile-app-development",
          },
          {
            label: "Multi-Tenant SaaS Product Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "multi-tenant-saas-product-development",
            link: "/services/development-services/multi-tenant-saas-product-development",
          },
          {
            label: "MVP Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "mvp-development",
            link: "/services/development-services/mvp-development",
          },
          {
            label: "NFT Token Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "nft-token-development",
            link: "/services/development-services/nft-token-development",
          },
          {
            label: "POC Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "poc-development",
            link: "/services/development-services/poc-development",
          },
          {
            label: "Product Engineering",
            iconPosition: "bg-[position:0px_0px]",
            item: "product-engineering",
            link: "/services/development-services/product-engineering",
          },
          {
            label: "SaaS Product Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "saas-product-development",
            link: "/services/development-services/saas-product-development",
          },
          
          {
            label: "Services Content",
            iconPosition: "bg-[position:0px_0px]",
            item: "services-content",
            link: "/services/development-services/services-content",
          },
          {
            label: "Software Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "software-development",
            link: "/services/development-services/software-development",
          },
          {
            label: "Web Portal Development",
            iconPosition: "bg-[position:0px_0px]",
            item: "web-portal-development",
            link: "/services/development-services/web-portal-development",
          },
        ],
      },
      {
        label: "Technologies/Languages",
        icon: markRaw(WrSettings),
        items: [
          { label: "View All", link: "/services/languages", iconPosition: "bg-[position:0px_0px]" },
          {
            label: "PHP",
            iconPosition: "bg-[position:-73px_0px]",
            item: "php",
            link: "/services/languages/php-development-services",
          },
          {
            label: ".NET",
            iconPosition: "bg-[position:-73px_-48px]",
            item: ".net",
            link: "/services/languages/dot-net-development-services",
          },
          {
            label: "Java",
            iconPosition: "bg-[position:-73px_-96px]",
            item: "java",
            link: "/services/languages/java-development-services",
          },
          {
            label: "Java Script",
            iconPosition: "bg-[position:-73px_-144px]",
            item: "javascript",
            link: "/services/languages/javascript-development-services",
          },
          {
            label: "Python",
            iconPosition: "bg-[position:-73px_-192px]",
            item: "python",
            link: "/services/languages/python-development-services",
          },
          {
            label: "Node JS",
            iconPosition: "bg-[position:-73px_-384px]",
            item: "node-js",
            link: "/services/languages/nodejs-development-services",
          },
          {
            label: "Mean Stack",
            iconPosition: "bg-[position:-73px_-432px]",
            item: "mean-stack",
            link: "/services/languages/mean-stack-development-services",
          },
          {
            label: "Ruby",
            iconPosition: "bg-[position:-73px_-480px]",
            item: "ruby",
            link: "/services/languages/ruby-development-services",
          },
          {
            label: "SharePoint",
            iconPosition: "bg-[position:-73px_-528px]",
            item: "sharepoint",
            link: "/services/languages/sharepoint-development-services",
          },
        ],
      },
      {
        label: "Frameworks",
        icon: markRaw(WrFrameworks),
        items: [
          { label: "View All", link: "/services/frameworks", iconPosition: "bg-[position:0px_0px]" },
          {
            label: "Backend",
            items: [
              {
                label: "Express",
                iconPosition: "bg-[position:-146px_0px]",
                item: "express",
                link: "/services/frameworks/express-development-services",
              },
              {
                label: "Django",
                iconPosition: "bg-[position:-146px_-48px]",
                item: "django",
                link: "/services/frameworks/django-development-services",
              },
              {
                label: "Laravel",
                iconPosition: "bg-[position:-146px_-144px]",
                item: "laravel",
                link: "/services/frameworks/laravel-development-services",
              },
              {
                label: "Spring",
                iconPosition: "bg-[position:-146px_-192px]",
                item: "spring",
                link: "/services/frameworks/spring-development-services",
              },
              {
                label: "AdonisJS",
                iconPosition: "bg-[position:-146px_-240px]",
                item: "adonisjs",
                link: "/services/frameworks/adonisjs-development-services",
              },
              {
                label: "CodeIgnitor",
                iconPosition: "bg-[position:-146px_-288px]",
                item: "codeignitor",
                link: "/services/frameworks/codeignitor-development-services",
              },
              {
                label: "CakePHP",
                iconPosition: "bg-[position:-146px_-336px]",
                item: "cakephp",
                link: "/services/frameworks/cakephp-development-services",
              },
              {
                label: "Sails.JS",
                iconPosition: "bg-[position:-146px_-384px]",
                item: "sails-js",
                link: "/services/frameworks/sails-js-development-services",
              },
              {
                label: "Yii",
                iconPosition: "bg-[position:-146px_-432px]",
                item: "yii",
                link: "/services/frameworks/yii-development-services",
              },
              {
                label: "Meteor",
                iconPosition: "bg-[position:-146px_-480px]",
                item: "meteor",
                link: "/services/frameworks/meteor-development-services",
              },
              {
                label: "Symfony",
                iconPosition: "bg-[position:-146px_-528px]",
                item: "symfony",
                link: "/services/frameworks/symfony-development-services",
              },
              {
                label: "Ruby on Rails",
                iconPosition: "bg-[position:-146px_-576px]",
                item: "ruby-on-rails",
                link: "/services/frameworks/ruby-on-rails-development-services",
              },
              {
                label: "Flask",
                iconPosition: "bg-[position:-146px_-624px]",
                item: "flask",
                link: "/services/frameworks/flask-development-services",
              },
              {
                label: "Pyramid",
                iconPosition: "bg-[position:-146px_-672px]",
                item: "pyramid",
                link: "/services/frameworks/pyramid-development-services",
              },
              {
                label: "Hadoop",
                iconPosition: "bg-[position:-146px_-720px]",
                item: "hadoop",
                link: "/services/frameworks/hadoop-development-services",
              },
            ],
          },
          {
            label: "Frontend",
            appendClass: "*:w-full shrink",
            items: [
              { label: "View All", link: "/services/frameworks" },
              {
                label: "VueJS",
                iconPosition: "bg-[position:-219px_0px]",
                item: "vuejs",
                link: "/services/frameworks/vuejs-development-services",
              },
              {
                label: "ReactJS",
                iconPosition: "bg-[position:-219px_-48px]",
                item: "reactjs",
                link: "/services/frameworks/reactjs-development-services",
              },
              {
                label: "AngularJS",
                iconPosition: "bg-[position:-219px_-96px]",
                item: "angularjs",
                link: "/services/frameworks/angularjs-development-services",
              },
              {
                label: "Ember",
                iconPosition: "bg-[position:-219px_-144px]",
                item: "ember",
                link: "/services/frameworks/ember-development-services",
              },
              {
                label: "Backbone",
                iconPosition: "bg-[position:-219px_-192px]",
                item: "backbone",
                link: "/services/frameworks/backbone-development-services",
              },
            ],
          },
        ],
      },
      {
        label: "CMS",
        icon: markRaw(WrFolder),
        items: [
          { label: "View All", link: "/services/cms-development", iconPosition: "bg-[position:0px_0px]" },
          {
            label: "WordPress",
            iconPosition: "bg-[position:-292px_0px]",
            item: "wordpress",
            link: "/services/cms-development/wordpress-development",
          },
          {
            label: "Drupal",
            iconPosition: "bg-[position:-292px_-49px]",
            item: "drupal",
            link: "/services/cms-development/drupal-development",
          },
          {
            label: "Magento",
            iconPosition: "bg-[position:-292px_-98px]",
            item: "magento",
            link: "/services/cms-development/magento-development",
          },
          {
            label: "Joomla",
            iconPosition: "bg-[position:-292px_-147px]",
            item: "joomla",
            link: "/services/cms-development/joomla-development",
          },
          {
            label: "Shopify",
            iconPosition: "bg-[position:-292px_-196px]",
            item: "shopify",
            link: "/services/cms-development/shopify-development",
          },
          {
            label: "Typo3",
            iconPosition: "bg-[position:-292px_-245px]",
            item: "typo3",
            link: "/services/cms-development/typo3-development",
          },
          {
            label: "Bitrix",
            iconPosition: "bg-[position:-292px_-294px]",
            item: "bitrix",
            link: "/services/cms-development/bitrix-development",
          },
          {
            label: "SquareSpace",
            iconPosition: "bg-[position:-292px_-343px]",
            item: "squarespace",
            link: "/services/cms-development/squarespace-development",
          },
          {
            label: "Prestashop",
            iconPosition: "bg-[position:-292px_-392px]",
            item: "prestashop",
            link: "/services/cms-development/prestashop-development",
          },
          {
            label: "Blogger",
            iconPosition: "bg-[position:-292px_-441px]",
            item: "blogger",
            link: "/services/cms-development/blogger-development",
          },
          {
            label: "vBulletin",
            iconPosition: "bg-[position:-292px_-490px]",
            item: "vbulletin",
            link: "/services/cms-development/vbulletin-development",
          },
          {
            label: "Wix",
            iconPosition: "bg-[position:-292px_-539px]",
            item: "wix",
            link: "/services/cms-development/wix-development",
          },
          {
            label: "Moodle",
            iconPosition: "bg-[position:-292px_-588px]",
            item: "moodle",
            link: "/services/cms-development/moodle-development",
          },
          {
            label: "WooCommerce",
            iconPosition: "bg-[position:-292px_-637px]",
            item: "woocommerce",
            link: "/services/cms-development/woocommerce-development",
          },
          {
            label: "Weebly",
            iconPosition: "bg-[position:-292px_-686px]",
            item: "weebly",
            link: "/services/cms-development/weebly-development",
          },
          {
            label: "ExpressionEngine",
            iconPosition: "bg-[position:-292px_-735px]",
            item: "expressionengine",
            link: "/services/cms-development/expressionengine-development",
          },
          {
            label: "Open Cart",
            iconPosition: "bg-[position:-292px_-784px]",
            item: "opencart",
            link: "/services/cms-development/opencart-development",
          },
          {
            label: "NopCommerce",
            iconPosition: "bg-[position:-292px_-833px]",
            item: "nopcommerce",
            link: "/services/cms-development/nopcommerce-development",
          },
          {
            label: "Umbraco",
            iconPosition: "bg-[position:-292px_-882px]",
            item: "umbraco",
            link: "/services/cms-development/umbraco-development",
          },
          {
            label: "Kentico",
            iconPosition: "bg-[position:-292px_-931px]",
            item: "kentico",
            link: "/services/cms-development/kentico-development",
          },
          {
            label: "Sitecore",
            iconPosition: "bg-[position:-292px_-980px]",
            item: "sitecore",
            link: "/services/cms-development/sitecore-development",
          },
          {
            label: "Keystonejs",
            iconPosition: "bg-[position:-292px_-1029px]",
            item: "keystonejs",
            link: "/services/cms-development/keystonejs-development",
          },
          {
            label: "Strapi",
            iconPosition: "bg-[position:-292px_-1078px]",
            item: "strapi",
            link: "/services/cms-development/strapi-development",
          },
          {
            label: "Ghost",
            iconPosition: "bg-[position:-292px_-1127px]",
            item: "ghost",
            link: "/services/cms-development/ghost-development",
          },
        ],
      },
      {
        label: "Mobility/Mobile Apps",
        icon: markRaw(WrMobile),
        items: [
          { label: "View All", link: "/services/mobility", iconPosition: "bg-[position:0px_0px]" },
          {
            label: "Android",
            iconPosition: "bg-[position:-365px_0px]",
            item: "android",
            link: "/services/mobility/android-app-development",
          },
          {
            label: "iOS",
            iconPosition: "bg-[position:-365px_-49px]",
            item: "ios",
            link: "/services/mobility/ios-app-development",
          },
          {
            label: "Hybrid Apps",
            iconPosition: "bg-[position:-365px_-98px]",
            item: "hybrid-apps",
            link: "/services/mobility/hybrid-app-development",
          },
          {
            label: "Xamarin",
            iconPosition: "bg-[position:-365px_-147px]",
            item: "xamarin",
            link: "/services/mobility/xamarin-app-development",
          },
          {
            label: "AR",
            iconPosition: "bg-[position:-365px_-196px]",
            item: "ar",
            link: "/services/mobility/ar-app-development",
          },
          {
            label: "VR",
            iconPosition: "bg-[position:-365px_-245px]",
            item: "vr",
            link: "/services/mobility/vr-app-development",
          },
          {
            label: "ReactNative",
            iconPosition: "bg-[position:-365px_-294px]",
            item: "reactnative",
            link: "/services/mobility/reactnative-app-development",
          },
          {
            label: "Flutter",
            iconPosition: "bg-[position:-365px_-343px]",
            item: "flutter",
            link: "/services/mobility/flutter-app-development",
          },
          {
            label: "NativeScript",
            iconPosition: "bg-[position:-365px_-392px]",
            item: "nativescript",
            link: "/services/mobility/nativescript-app-development",
          },
          {
            label: "Unity",
            iconPosition: "bg-[position:-365px_-441px]",
            item: "unity",
            link: "/services/mobility/unity-app-development",
          },
          {
            label: "Apple Watch App Development",
            iconPosition: "bg-[position:-365px_-490px]",
            item: "apple-watch",
            link: "/services/mobility/apple-watch-app-development",
          },
          {
            label: "Tizen Application Development",
            iconPosition: "bg-[position:-365px_-539px]",
            item: "tizen",
            link: "/services/mobility/tizen-app-development",
          },
          {
            label: "iBeacon App Development Company",
            iconPosition: "bg-[position:-365px_-588px]",
            item: "ibeacon",
            link: "/services/mobility/ibeacon-app-development",
          },
          {
            label: "PhoneGap Development Company",
            iconPosition: "bg-[position:-365px_-637px]",
            item: "phonegap",
            link: "/services/mobility/phonegap-app-development",
          },
          {
            label: "Ionic Framework",
            iconPosition: "bg-[position:-365px_-686px]",
            item: "ionic",
            link: "/services/mobility/ionic-app-development",
          },
        ],
      },
      {
        label: "Desktop",
        icon: markRaw(WrDesktop),
        items: [
          {
            label: "View All",
            link: "/services/desktop",
            iconPosition: "bg-[position:0px_0px]",
          },
          {
            label: "Windows Application Development",
            iconPosition: "bg-[position:-438px_0px]",
            item: "windows",
            link: "/services/desktop/windows-software-development",
          },
          {
            label: "MAC Software Development",
            iconPosition: "bg-[position:-438px_-48px]",
            item: "mac",
            link: "/services/desktop/mac-software-development",
          },
          {
            label: "Cocoa Software Framework",
            iconPosition: "bg-[position:-438px_-96px]",
            item: "cocoa",
            link: "/services/desktop/cocoa-software-development",
          },
          {
            label: "Electron Software Development",
            iconPosition: "bg-[position:-438px_-144px]",
            item: "electron",
            link: "/services/desktop/electron-software-development",
          },
        ],
      },
      {
        label: "Artificial Intelligence (AI)",
        icon: markRaw(WrAI),
        items: [
          {
            label: "View All",
            link: "/services/ai",
            iconPosition: "bg-[position:0px_0px]",
          },
              {
            label: "Machine Learning",
            iconPosition: "bg-[position:-511px_-50px]",
            item: "machine-learning",
            link: "/services/ai/machine-learning",
          },
          {
            label: "Deep Learning",
            iconPosition: "bg-[position:-511px_-100px]",
            item: "deep-learning",
            link: "/services/ai/deep-learning",
          },
          {
            label: "Predictive Analysis",
            iconPosition: "bg-[position:-511px_-150px]",
            item: "predictive-analysis",
            link: "/services/ai/predictive-analysis",
          },
          {
            label: "Image Processing",
            iconPosition: "bg-[position:-511px_-200px]",
            item: "image-processing",
            link: "/services/ai/image-processing",
          },
          {
            label: "Natural Language Processing",
            iconPosition: "bg-[position:-511px_-250px]",
            item: "nlp",
            link: "/services/ai/natural-language-processing",
          },
          {
            label: "Virtual Assistants",
            iconPosition: "bg-[position:-511px_-300px]",
            item: "virtual-assistants",
            link: "/services/ai/virtual-assistants",
          },
          {
            label: "Text & Natural Language Processing",
            iconPosition: "bg-[position:-511px_-350px]",
            item: "text-nlp",
            link: "/services/ai/text-natural-language-processing",
          },
          {
            label: "Images, Video & Computer Vision",
            iconPosition: "bg-[position:-511px_-400px]",
            item: "vision",
            link: "/services/ai/images-video-computer-vision",
          },
          {
            label: "Search Relevance",
            iconPosition: "bg-[position:-511px_-450px]",
            item: "search-relevance",
            link: "/services/ai/search-relevance",
          },
          {
            label: "Data Enrichment & Categorization",
            iconPosition: "bg-[position:-511px_-500px]",
            item: "data-enrichment",
            link: "/services/ai/data-enrichment-categorization",
          },
          {
            label: "Audio & Speech-to-Text",
            iconPosition: "bg-[position:-511px_-550px]",
            item: "speech-to-text",
            link: "/services/ai/audio-speech-to-text",
          },
          {
            label: "Assisted Data Labeling",
            iconPosition: "bg-[position:-511px_-600px]",
            item: "data-labeling",
            link: "/services/ai/assisted-data-labeling",
          },
          {
            label: "Assisted Video Object Tracking",
            iconPosition: "bg-[position:-511px_-650px]",
            item: "video-tracking",
            link: "/services/ai/assisted-video-object-tracking",
          },
          {
            label: "Model Creation",
            iconPosition: "bg-[position:-511px_-750px]",
            item: "model-creation",
            link: "/services/ai/model-creation",
          },
          {
            label: "Sentiment Analysis",
            iconPosition: "bg-[position:-511px_-800px]",
            item: "sentiment-analysis",
            link: "/services/ai/sentiment-analysis",
          },
          {
            label: "Text Categorization/classification",
            iconPosition: "bg-[position:-511px_-850px]",
            item: "text-categorization",
            link: "/services/ai/text-categorization-classification",
          },
          {
            label: "Intent Classification",
            iconPosition: "bg-[position:-511px_-900px]",
            item: "intent-classification",
            link: "/services/ai/intent-classification",
          },
          {
            label: "Entity Recognition",
            iconPosition: "bg-[position:-511px_-950px]",
            item: "entity-recognition",
            link: "/services/ai/entity-recognition",
          },
        ],
      },
      {
        label: "Industries",
        icon: markRaw(WrIndustries),
        items: [
          {
            label: "View All",
            link: "/services/industries",
            iconPosition: "bg-[position:0px_0px]",
          },
          {
            label: "Health Care and Fitness",
            iconPosition: "bg-[position:0px_0px]",
            item: "ai-agent-development",
            link: "/services/industries/health-care-and-fitness",
          },
          {
            label: "Education and Training",
            iconPosition: "bg-[position:0px_0px]",
            item: "ai-chatbot-development",
            link: "/services/industries/education-and-training",
          },
          {
            label: "Retail and eCommerce",
            iconPosition: "bg-[position:0px_0px]",
            item: "machine-learning",
            link: "/services/industries/retail-and-ecommerce",
          },
          {
            label: "Sports and Entertainment",
            iconPosition: "bg-[position:0px_0px]",
            item: "deep-learning",
            link: "/services/industries/sports-and-entertainment",
          },
          {
            label: "Media and Publishing",
            iconPosition: "bg-[position:0px_0px]",
            item: "predictive-analysis",
            link: "/services/industries/media-and-publishing",
          },
          {
            label: "Food and Beverage",
            iconPosition: "bg-[position:0px_0px]",
            item: "image-processing",
            link: "/services/industries/food-and-beverage",
          },
        ],
      },
      {
        label: "Maintenance Services",
        icon: markRaw(WrProducts),
        items: [
          {
            label: "View All",
            link: "/services/maintenance-services",
            iconPosition: "bg-[position:0px_0px]",
          },
          {
            label: "Laravel Maintenance Services",
            iconPosition: "bg-[position:0px_0px]",
            item: "ai-agent-development",
            link: "/services/maintenance-services/laravel",
          },
          {
            label: "WordPress Maintenance Services",
            iconPosition: "bg-[position:0px_0px]",
            item: "ai-chatbot-development",
            link: "/services/maintenance-services/wordpress",
          },
          {
            label: "Mobile App Maintenance Services",
            iconPosition: "bg-[position:0px_0px]",
            item: "machine-learning",
            link: "/services/maintenance-services/mobile-apps",
          },
        ],
      },
    ],
  },
  {
    label: "Solutions",
    items: [
      {
        label: "View All",
        link: "/solutions"
      },
      { label: "CRM", link: "/solutions/crm-development-services" },
      { label: "ERP", link: "/solutions/erp-development-services" },
      {
        label: "Survey Software",
        link: "/solutions/survey-software-development-services",
      },
      {
        label: "Project Management System",
        link: "/solutions/project-management-systems-development-services",
      },
      {
        label: "Restaurant Management Software",
        link: "/solutions/restaurant-management-software-development-services",
      },
      {
        label: "Warehouse Automation",
        link: "/solutions/warehouse-automation-development-services",
      },
      {
        label: "Time Tracking Software",
        link: "/solutions/time-tracking-software-development-services",
      },
      {
        label: "Visitor Management Software",
        link: "/solutions/visitor-management-software-development-services",
      },
      {
        label: "Inventory Management System",
        link: "/solutions/inventory-management-systems-development-services",
      },
      { label: "FAS", link: "/solutions/fixed-asset-management-accounting-software-fas-development-services" },
      { label: "View All", link: "/solutions" },
    ],
  },
  {
    label: "Products",
    items: [
      {
        label: "View All",
        link: "/products"
      },
      {
        label: "vaahcms",
        link: "/services/cms-development/wordpress-development",
      },
      {
        label: "vaahcli",
        link: "/products",
      },
      {
        label: "Laravel USPS",
        link: "/products",
      },
      {
        label: "Laravel Nestable",
        link: "/products",
      },
      {
        label: "VaahCMS Module CMS",
        link: "/products",
      },
      {
        label: "Laravel cPanel",
        link: "/products",
      },
      {
        label: "VaahNuxt",
        link: "/products",
      },
      {
        label: "VaahCMS Module Saas",
        link: "/products",
      },
    ],
  },
  {
    label: "Company",
    items: [
      { label: "View All", link: "/company" },
      { label: "About Us", link: "/about-us" },
      { label: "Case Studies", link: "/case-studies" },
      { label: "How We Work", link: "/how-we-work" },
      { label: "Capabilities", link: "/capabilities" },
      { label: "Dedicated Team", link: "/dedicated-team" },
      { label: "Staff Augmentation", link: "/staff-augmentation" },
      { label: "Testimonials", link: "/testimonials" },
      { label: "Careers", link: "/career" },
    ],
  },
]);
</script>
